<!-- collection title  -->
  
document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM content loaded');

    // Handle search form submission
    function handleSearchFormSubmit(event) {
        event.preventDefault();
        const searchInput = event.target.querySelector('input[name="q"]');
        const searchQuery = searchInput?.value.trim();

        if (!searchQuery) return console.error('Search query is empty or search input not found.');

        const collectionHandle = searchQuery.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const collectionUrl = `/collections/${encodeURIComponent(collectionHandle)}`;
        const searchUrl = `/search?q=${encodeURIComponent(searchQuery)}&type=product&collection=all`;

        // Redirect based on collection existence
        fetch(collectionUrl).then(response => {
            window.location.href = response.ok ? collectionUrl : searchUrl;
        }).catch(() => window.location.href = searchUrl);
    }

    // Attach event listener to search forms
    ['form[action="/search"]', '.header__search details form[action="/search"]'].forEach(selector => {
        const form = document.querySelector(selector);
        form?.addEventListener('submit', handleSearchFormSubmit);
    });
});